import { graphql } from '@graphql/__generated'

export const GET_BLACKBAUD_CONSTITUENT_OPTIONS = graphql(`
  query getBlackBaudConstituentOptions($email: String!) {
    getConstituentOptions(email: $email) {
      name
      email
      title
      id
      postalAddress
      dietaryRequirements
      summary_note
    }
  }
`)
